import { BITF_CONFIGS as COMMON_BITF_CONFIGS } from '@common/configs/common-bitf.configs';

const WEB_BITF_CONFIGS = {
  urls: { homePageUrl: '/', signInUrl: 'auth/sign-in', signOutUrl: 'auth/sign-in' },
  pwa: { serviceWorker: { checkUpdateInterval: 30000 }, installPrompt: { askAgainAfterNDays: 10 } },
};

export const BITF_CONFIGS = Object.assign(COMMON_BITF_CONFIGS, WEB_BITF_CONFIGS);
